// Universal safe Firebase wrapper. Use this file everywhere.
// It conditionally loads the browser implementation to avoid IndexedDB access on the server.

const isBrowser = typeof window !== "undefined";
let client: any = null;
if (isBrowser) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    client = require("./firebase.client");
  } catch (e) {
    console.error("firebase.client load failed", e);
  }
}

export const analytics = isBrowser ? client?.analytics ?? null : null;
export const messaging = isBrowser ? client?.messaging ?? null : null;
export const fetchToken: () => Promise<string | null> = isBrowser ? client?.fetchToken : async () => null;
export const requestNotificationPermission: () => Promise<string | null> = isBrowser
  ? client?.requestNotificationPermission
  : async () => null;
export const messagingInstance: () => Promise<any> = isBrowser ? client?.messagingInstance : async () => null;
export const db = isBrowser ? client?.db ?? null : null;
export const app = isBrowser ? client?.app ?? null : null;
